export class AutomationEntry {

    /** Unique internal identity of the automation log entry. */
    public id: number = 0
    
    /** Unique internal identity of the corporation associated with the automation log entry. */
    public corporateId: number = 0
    
    /** Unique internal identity of the lot associated with the automation log entry. */
    public lotId: number = 0

    /** Name of the lot associated with the automation log entry. */
    public lot: string = ''
    
    /** The type of automation job this entry represents. */
    public jobType: 'computeTerms' | 'computeStats' | 'applyLateFees' = 'computeTerms'
    
    /** The current status of the automation job. */
    public status: 'pending' | 'running' |  'success' | 'failure' = 'pending'
    
    /** Date and time the automation job started running. */
    public startedAt: Date | null = null
    
    /** Date and time the automation job failed or completed. */
    public completedAt: Date | null = null
    
    /** The numbe rof milliseconds it took for the job to run. */
    public duration: number = 0
    
    /** The number of items that successfully completed during the job run. */
    public itemsProcessed: number = 0
    
    /** The number of items that failed to complete during the job run. */
    public itemsFailed: number = 0
    
    /** An optional custom asOf date provided to the automation job. */
    public asOf: string | null =  null
    
    /** The latest error message produced by the job, if any. */
    public errorMessage: string | null = null
    
    /** Mixed information related to the job run. Might be a list of errors or a list of successes or both. */
    public meta: string | null = null

}